// src/pages/MS/MSC101F1.jsx
import React, {useEffect, useState} from 'react';

import DataGrid from "components/DataGrid/DataGrid";
import {postData} from "utils/TransactionUtil";

import style from "./MSC101F1.module.scss";
import SelectBox from "../../components/SelectBox/SelectBox";
import Button from "../../components/Button/Button";
import Icon from "../../components/Icon/Icon";


const ButtonFormatter = ({ row }) => {
    if(row.modInfo) {
        return (
            <button title={row.modInfo}>
                <Icon id="edit_01" width="16" height="17"/>
            </button>
        );
    }
    return null;
};

const MSC101F1 = ({navBar: NavBar}) => {

    //검색 조건
    const [schGb, setSchGb] = useState();
    const [schNm, setSchNm] = useState();

    //그룹코드
    const [rows_ComCdGrp, setRows_ComCdGrp] = useState([]);
    const cols_ComCdGrp = [
        { key: 'st',         name: '상태',        width: '10%', sortable:'true' },
        { key: 'sqnc',       name: 'NO',         width: '10%', renderCell: ({ rowIdx }) => rowIdx+1 },
        { key: 'comnGrpCd',  name: '그룹코드',     width: '35%', cellClass: 'align_left' },
        { key: 'grpNm',      name: '그룹코드명',   width: '35%', cellClass: 'align_left' },
        { key: 'modInfo', name: '수정정보',      width: '10%', renderCell: ButtonFormatter}
    ];

    //상세코드
    const [rows_ComCdDtl, setRows_ComCdDtl] = useState([]);
    const cols_ComCdDtl = [
        { key: 'st',            name: '상태',        width: '5%', sortable:'true' },
        { key: 'scrnDsplSqnc',  name: '순서',        width: '5%'},
        { key: 'useYn',         name: '사용여부',     width: '10%'},
        { key: 'comnDtlsCd',    name: '상세코드',     },
        { key: 'detlCdNm',      name: '코드명-국문',   width: '30%', cellClass: 'align_left' },
        { key: 'detlCdEnsnNm',  name: '코드명-영문',   width: '25%', cellClass: 'align_left' },
        { key: 'modInfo', name: '수정정보',   width: '10%',   renderCell: ButtonFormatter}
    ];

    useEffect(() => {

        getComCdGrpList(); //그룹 공통 코드 조회

    }, []);

    //그룹코드 row 클릭
    const handleClick_ComCdGrp = (e) => {
        getComCdDtlList(e.row,e.column.key).then(() => {});
    }

    //공통 코드 그룹 조회
    async function getComCdGrpList(){
        let param = {

        }

        const res = await postData("/MSC/getComCdGrpList", param);
        setRows_ComCdGrp(res);
    }

    //공통 코드 상세 조회
    async function getComCdDtlList(row, key){
        let param = {
            schCd : row.comnGrpCd
        }

        const res = await postData("/MSC/getComCdDtlList", param);
        setRows_ComCdDtl(res);
    }


    return(
        <main className={style.main_wrap}>
            <NavBar>
                {/*검색영역*/}
                <div className={style.search_wrap}>
                    <SelectBox
                        options={[{val:"1", lab:"그룹코드"}, {val:"2", lab:"그룹코드명"}, {val:"3", lab:"상세코드"}, {val:"4", lab:"상세코드명"}]}
                        valueKey="val" labelKey="lab"
                        value={schGb}
                        onChange={(val) => setSchGb(val)}
                        width = "240px"
                        isAllExpr={false}
                        />
                    <input
                        type="text"
                        className={style.schNm}
                        defaultValue={schNm}
                        //ref={lginIdInputRef}
                        placeholder={"검색어를 입력해 주세요."}
                        maxLength={40}
                        onChange={(e) => setSchNm(e.target.value)}
                        />
                    <Button variant="Secondary" size="md" addStyle={{width: "82px", height: "40px"}}>
                        조회
                        <Icon id="rightAngleBrackets_02" width="16" height="16"/>
                    </Button>
                    <Button variant="Primary" size="md" addStyle={{width: "58px", height: "40px"}}>
                        저장
                    </Button>
                </div>
            </NavBar>
            {/*내용*/}
            <div className={style.main_cont}>
                <div className={style.cont_item}>
                    <div className={style.info_grp}>
                        <h3>그룹코드</h3><label>[총 <span>{rows_ComCdGrp.length}건</span> ]</label>
                        <div className={style.btn_grp}>
                            <Button variant="Secondary" size="sm" addStyle={{width: "71px", height: "32px"}}>
                                추가 <Icon id="plus_01" width="16" height="16"/>
                            </Button>
                            <Button variant="Tertiary" size="sm" addStyle={{width: "71px", height: "32px"}}>
                                삭제 <Icon id="minus_01" width="16" height="16"/>
                            </Button>
                        </div>
                    </div>
                    <div className={style.grad_wrap}>
                        <DataGrid
                            cols={cols_ComCdGrp}
                            rows={rows_ComCdGrp}
                            size='md'
                            headerRowHeight={37}
                            rowHeight={37}
                            onCellClick={(e) => handleClick_ComCdGrp(e)}
                        />
                    </div>
                 </div>
                 <div className={style.cont_item}>
                    <div className={style.info_grp}>
                        <h3>상세코드</h3><label>[총 <span>{rows_ComCdDtl.length}건</span> ]</label>
                        <div className={style.btn_grp}>
                            <Button variant="Secondary" size="sm" addStyle={{width: "71px", height: "32px"}}>
                                추가 <Icon id="plus_01" width="16" height="16"/>
                            </Button>
                            <Button variant="Tertiary" size="sm" addStyle={{width: "71px", height: "32px"}}>
                                삭제 <Icon id="minus_01" width="16" height="16"/>
                            </Button>
                        </div>
                    </div>
                     <div className={style.grad_wrap}>
                         <DataGrid
                             cols={cols_ComCdDtl}
                             rows={rows_ComCdDtl}
                             size='md'
                             headerRowHeight={37}
                             rowHeight={37}
                             //onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                         />
                     </div>
                 </div>
             </div>
        </main>
    )
}
export default MSC101F1;
